export const ReactSelectInputTranslation = {
  fi: {
    ReactSelectInput: {
      noOptionsMessage: 'Ei vaihtoehtoja',
      loading: 'Ladataan tietoja...',
    },
  },
};
